module.exports = __webpack_public_path__ + "media/images/footer-linkedin-icon-d9f14dedab366e03fd50a8eb8f3ef350.png";